import withErrorCheck from "../CheckError";
import server from "../Server";
import type { GetGroupTopEXPPayload, ITopEXP } from "@grassrootly/api/entities";

// Fetch top 10 EXP earners for a group from player_games_view
export const GetGroupTopEXP = async ({ groupId }: GetGroupTopEXPPayload): Promise<ITopEXP[]> => {
  const response = await server
    .from("player_games_view")
    .select([
      "player_id",
      "player_name", 
      "player_profile_picture",
      "player_points_earned",
      "game_datetime",
      "game_id"
    ].join(","))
    .eq("group_id", groupId)
    .gt("player_points_earned", 0) // Only include games where EXP was earned
    .order("player_points_earned", { ascending: false })
    .order("game_datetime", { ascending: false }) // Secondary sort by most recent
    .limit(10);

  const data = withErrorCheck<ITopEXP[]>(response as any) || [];
  return data;
};
